import { Box, Typography } from '@mui/material';

import { FORTA_ERROR, FORTA_GRAY3, FORTA_SUCCESS, FORTA_WHITE } from '../../../../utils/colors';

interface CriteriaCardProps {
  title: string;
  result: boolean | null;
  sx?: any;
}
function CriteriaCard(props: CriteriaCardProps) {
  const { title, result } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: '80px',
        padding: '16px',
        marginBottom: '16px',
        borderRadius: '10px',
        backgroundColor: FORTA_WHITE,
        gap: '16px',
      }}
    >
      <Typography
        sx={{
          textAlign: 'left',
          fontSize: '20px',
          lineHeight: '28px',
          whiteSpace: 'pre-line',
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '140px',
          height: '48px',
          padding: result === null ? '4px 8px' : '8px 16px',
          borderRadius: '10px',
          border: `2px solid ${
            result === null ? FORTA_GRAY3 : result ? FORTA_SUCCESS : FORTA_ERROR
          }`,
        }}
      >
        <Typography
          sx={{
            fontSize: result === null ? '16px' : '24px',
            fontWeight: 700,
            color: result === null ? FORTA_GRAY3 : result ? FORTA_SUCCESS : FORTA_ERROR,
          }}
        >
          {result === null ? 'Not evaluated' : result ? 'Pass' : 'Fail'}
        </Typography>
      </Box>
    </Box>
  );
}
export default CriteriaCard;
